define('_views/Star',[
	'text!_templates/star.html',
	'_views/Fan-modal'
],
function(
	starTemplate,
	FanModal
) {

	return Backbone.View.extend({

		id: 'star',

		template: _.template(starTemplate),

		events: {
			'click' : 'toggleFan'
		},

		initialize: function(){

		},

		render: function(){

			this.$el.html(
				this.template({
					defaults : this.model.toJSON()
				})
			);

			return this;
		},

		toggleFan: function(e) {
			var _this = this;
			if(this.model.get('is_owner') === true || this.model.get('cookie_is_upgraded') === false) {
				return;
			}

			if(this.model.get('cookie_is_demo') === true) {

				parent.window.Cargo.Modal.Confirm({
					message: "<em>You’ve not yet saved your Persona, click OK to do so</em>",
					selector: 'html',
					confirm: function(){
						top.document.location.href = _this.model.get('cookie_direct_link') + '/admin/settings';
					}
				});

				return;
			}

			var modal = new FanModal({
				model: this.model
			});

			modal.render();

		}
		
	});

});

